import client from '../session/apiClient';

class ReviewResponseTemplateAPI {
  loadTemplates =() => {
    return client.get("/reviewResponseTemplates").then(response => {
      return response.data
    })
  };

  deleteTemplate =(id) => {
    client.delete(`/reviewResponseTemplates/${id}`)
  };

  updateTemplate =(id, name, body, sentimentType) => {
    client.post(`/reviewResponseTemplates/${id}`, {name: name, body: body, sentimentType: sentimentType}).then(response => {
      return response.data
    })
  };

  createTemplate =(name, body, sentimentType) => {
    return client.post(`/reviewResponseTemplates`, {
      name: name,
      body: body,
      sentimentType: sentimentType
    }).then(response => {
      return response.data
    })
  }
}

export default new ReviewResponseTemplateAPI();